import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, } from "@nextui-org/react";
import { useAuth, useFirestore, useFirestoreCollectionData, useUser } from "reactfire";
import { collection, where, query, onSnapshot, orderBy } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { NewComparator } from "./newComparator";
import { useEffect, useState } from "react";

const Comparators = () => {
    const firestore = useFirestore();
    const navigate = useNavigate(); 
    const auth = useAuth(); 

    const [comparators, setComparators] = useState<any>();
    const dateFormatter = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });

    useEffect(()=>{
        const fetchData = async () => {
            
            if (auth.currentUser) {
                const q = query(collection(firestore, "comparators"), where("createdBy", "==", auth.currentUser?.uid), orderBy('lastUpdated', 'desc'));

                const unsubscribe = onSnapshot(q, (querySnapshot) => {
                    const docs:Array<any> = [];
                    querySnapshot.forEach((doc) => {
                        docs.push({ ...doc.data(), id: doc.id });
                    });
                    setComparators(docs);
                });
            }
        }
        fetchData(); 
    }, []);
    
    return (
        <>
            <div className="flex justify-between">
                <div className="text-2xl font-bold">Comparators</div>
                <NewComparator />
            </div>
            <br></br>
            <Table
                aria-label="Comparators"
                selectionMode="single"
            >
                <TableHeader>
                    <TableColumn>Name</TableColumn>
                    <TableColumn>Description</TableColumn>
                    <TableColumn>Created By</TableColumn>
                    <TableColumn>Last Updated</TableColumn>
                </TableHeader>
                <TableBody 
                    emptyContent={"No rows to display"}>
                    {comparators?.map((comparator: any) => (
                        //TODO: paginated table 
                        
                        <TableRow key={comparator.id} onClick={()=>navigate(`/comparators/${comparator.id}`)}>
                            <TableCell>{comparator.name}</TableCell>
                            <TableCell>{comparator.description}</TableCell>
                            <TableCell>{comparator.createdByName}</TableCell>
                            <TableCell>{dateFormatter.format(new Date(comparator.lastUpdated))}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    )
}


export default Comparators; 